import {SERVICE_INTERVALS_DEFAULT_VALUES, ServiceVehicle} from '@dms/features/vehicle-forms-kit';

/**
 * Creates default values for rental vehicle form with all service intervals set to null
 * @returns Object containing default service intervals with null values
 */
export const CREATE_SERVICE_VEHICLE_DEFAULT_VALUES: Partial<ServiceVehicle> = {
  type: ['VEHICLETYPE_PASSENGER_CAR'],
  serviceIntervals: SERVICE_INTERVALS_DEFAULT_VALUES,
  warranties: [],
};
